module.exports = __webpack_public_path__ + "static/media/MM.386487d6.svg";